import apiClient from './client'
import type { User, LoginCredentials, RegisterData, AuthTokens } from '@/types'

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthTokens & { user: User } | { requires_2fa: true; email: string }> => {
    const response = await apiClient.post('/auth/login/', credentials)
    return response.data
  },

  login2FA: async (data: { email: string; password: string; token: string }): Promise<AuthTokens & { user: User }> => {
    const response = await apiClient.post('/auth/2fa/login/', data)
    return response.data
  },

  register: async (data: RegisterData): Promise<{ user: User; message: string }> => {
    const response = await apiClient.post('/auth/register/', data)
    return response.data
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout/')
  },

  refreshToken: async (refreshToken: string): Promise<{ access: string }> => {
    const response = await apiClient.post('/auth/refresh/', { refresh: refreshToken })
    return response.data
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get('/auth/me/')
    return response.data
  },

  updateProfile: async (data: Partial<User>): Promise<User> => {
    const response = await apiClient.patch('/auth/me/', data)
    return response.data
  },

  updateAvatar: async (file: File): Promise<{ avatar: string }> => {
    const formData = new FormData()
    formData.append('avatar', file)
    const response = await apiClient.patch('/auth/me/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  changePassword: async (data: { old_password: string; new_password: string; new_password_confirm: string }): Promise<void> => {
    await apiClient.post('/auth/password/change/', data)
  },

  requestPasswordReset: async (email: string): Promise<void> => {
    await apiClient.post('/auth/password/reset/', { email })
  },

  confirmPasswordReset: async (data: { token: string; password: string }): Promise<void> => {
    await apiClient.post('/auth/password/confirm/', data)
  },

  setup2FA: async (): Promise<{ qr_code: string; secret: string }> => {
    const response = await apiClient.post('/auth/2fa/setup/')
    return response.data
  },

  verify2FA: async (code: string): Promise<void> => {
    await apiClient.post('/auth/2fa/verify/', { token: code })
  },

  disable2FA: async (code: string): Promise<void> => {
    await apiClient.post('/auth/2fa/disable/', { token: code })
  },
}
